var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',[_c('v-btn',{attrs:{"small":"","text":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.$t('logs.actions.goToSource')))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }